
import axios from "axios"
import store from '../store'
import router from '../router'

import app from '../main'

import moment from "moment"
require('moment/locale/tr')

import domtoimage from 'dom-to-image';
import { jsPDF } from "jspdf";
import { PDFDocument } from 'pdf-lib'
import * as XLSX from 'xlsx/xlsx.mjs'
import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';


axios.defaults.baseURL = process.env.VUE_APP_API_HOOK


axios.interceptors.request.use( (request)=> {
    let token = store.state.auth.token
    let userip = store.state.auth.userip
    
    if(token !=="")
    {
    	request.headers = { 
	      'Authorization': `Bearer ${token}`,
	      'Accept': 'application/json',
	      'Content-Type': 'application/x-www-form-urlencoded',
          'userip':userip
	    }
    }
    
    return request;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });



export const submission = {

data() {
    return {
    	publicPath: process.env.BASE_URL,
        moment:null,
        apibaseurl:process.env.VUE_APP_APP_ROOT,
        general_apiurl:"https://storage.googleapis.com/verifycloud/",
        workbook:null,
        worksheet:null,
        activerow:1,
        questionlist_options:[]
    };
  },
  created()
  {
    this.moment = moment;
    this.onResize()
    window.addEventListener('resize', () => { this.onResize() });
  },
  mounted()
  {
    //this.onResize()
    


  },
  computed:{
    userleftmenuitems()
    {
        return this.checkUserMenu()
    },
    is_user_supplier()
    {
        let user = store.state.auth.user
        if(user)
        {
            let roles = store.state.auth.user.userroles
            roles = roles.map((item)=>{return item.name})
            if(roles.includes("supplier"))
            {
                return true
            }
            return false
        }
        return false
    },

    
  },
methods:{
    async downloadSelfEvalMarkingReport(payload)
    {
        let data = await this.generalApiGetWithoutLoader("audit/"+payload.flowsupplier.uuid)
        let audit_inputfields_data = await this.generalApiGetWithoutLoader("audit/get_audit_inputfields_data/"+payload.flowsupplier.uuid)
        await this.arrangeAuditInputfields(audit_inputfields_data)
        const options = {
            useStyles: true,
            useSharedStrings: true,
        };
        this.workbook = new ExcelJS.Workbook();
        this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.soru_listesi_isaretlemeleri);
        for (let index = 0; index < store.state.evaluation.parentsections.length; index++)
        {
            if(store.state.evaluation.parentsections.length>1)
            {
              let section_name = this.getNameTranslation(store.state.evaluation.parentsections[index])
              this.worksheet.addRow([section_name]);

              this.worksheet.getCell('A'+this.activerow).fill = {
                  type: 'pattern',
                  pattern:'solid',
                  fgColor:{argb:'FF91D2FF'}
              };
              this.activerow++
            }

            let child_inputfields = this.getSectionInputfieldsForReport(store.state.evaluation.parentsections[index].id)
            for(let inputfield of child_inputfields)
            {

              this.addInputfieldName(inputfield,payload)
            }
            this.getChildSections(store.state.evaluation.parentsections[index].id,payload)
        }
        this.activerow = 1

        //points worksheet
        if(this.data.quizresult)
        {
            this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.puan);
            this.worksheet.addRow([store.state.languages.lang_phrases.puan,this.data.quizresult.percentage_over_points +" / "+ this.data.quizresult.points.toFixed(2)]);
            this.worksheet.getCell('A'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'FF91D2FF'}
                };
            this.worksheet.getCell('B'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'ffa4ffa4'}
                };
            this.activerow++
            this.worksheet.addRow([store.state.languages.lang_phrases.basari_yuzdesi,this.data.quizresult.percentage+"%"]);
            this.worksheet.getCell('A'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'FF91D2FF'}
                };
            this.worksheet.getCell('B'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'ffa4ffa4'}
                };
        }
        //points worksheet
        this.workbook.xlsx.writeBuffer()
        let flowname= this.getTheTranslation(payload.flowsupplier.flow,"translation")
        this.workbook.xlsx.writeBuffer()
        .then(buffer => saveAs(new Blob([buffer]), `${payload.flowsupplier.supplier.name+"-"+flowname}.xlsx`))
        this.activerow = 1
        this.workbook =null
        this.worksheet =null
    },

    async downloadAuditMarkingReport(payload)
    {
        console.log("downloadAuditMarkingReport")
        console.log(payload)
        let data = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_data_questions/"+payload.flowsupplier.audit.uuid) 
        await store.dispatch('audit/setQuestionlist',data)
        let audit_inputfields_data = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_inputfields_data/"+payload.flowsupplier.audit.uuid)

        await store.dispatch('evaluation/setNullreasons',audit_inputfields_data.nullreasons) 
        await store.dispatch('evaluation/setCustomattributes',audit_inputfields_data.customattributes) 
        for(let condition of audit_inputfields_data.questionlist_conditions)
        {
            condition.conditions = await JSON.parse(condition.conditions)
            condition.outcome = await JSON.parse(condition.outcome)
        }
        await store.dispatch('evaluation/setQuestionlistConditions',audit_inputfields_data.questionlist_conditions) 
        await this.arrangeAuditInputfields(audit_inputfields_data)

        if(data.type=="same_question_pattern")
        {
            let inputfields = await store.state.evaluation.inputfields
            for(let item of inputfields)
            {
                item.columns = await data.columns
                item.options = await data.options
            }
            await store.dispatch('evaluation/setInputfields',inputfields)
        }
        const options = {
            useStyles: true,
            useSharedStrings: true,
        };
        this.workbook = new ExcelJS.Workbook();

        //cover
        this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.kapak);
        this.worksheet.addRow([store.state.languages.lang_phrases.tedarikci,payload.flowsupplier.supplier.name]);
        this.activerow++
        this.worksheet.addRow([store.state.languages.lang_phrases.tedarikci_kodu,payload.flowsupplier.supplier.suppliercode]);
        this.activerow++
        //auditor
        if(payload.flowsupplier.audit && payload.flowsupplier.audit.auditor)
        {
            this.worksheet.addRow([store.state.languages.lang_phrases.denetci,payload.flowsupplier.audit.auditor.user.name]);
        }
        else
        {
            this.worksheet.addRow([store.state.languages.lang_phrases.denetci]);
        }
        //auditor
        //audit date
        if(payload.flowsupplier.audit && payload.flowsupplier.audit.schedule_date)
        {
            this.worksheet.addRow([store.state.languages.lang_phrases.oturum_tarihi,payload.flowsupplier.audit.schedule_date]);
        }
        else
        {
            this.worksheet.addRow([store.state.languages.lang_phrases.oturum_tarihi]);
        }
        //audit date
        //inputfieldclasses
        if(payload.flowsupplier.audit && payload.flowsupplier.audit.inputfieldclasses.length)
        {
            let classes = ""
            for(let inputfieldclass of payload.flowsupplier.audit.inputfieldclasses)
            {
                classes = classes+inputfieldclass.name+", "
            }
            
            classes = classes.slice(0, -2); 
            this.worksheet.addRow([store.state.languages.lang_phrases.soru_siniflari,classes]);
        }
        else
        {
            this.worksheet.addRow([store.state.languages.lang_phrases.soru_siniflari]);
        }
        //inputfieldclasses

        //flowattributes
        if(payload.flowsupplier.flow.flowattributes.length)
        {
            for(let flowattribute of payload.flowsupplier.flow.flowattributes)
            {
                let attribute_name = this.getTheTranslation(flowattribute.customattribute,'translation')
                let the_val = "-"
                if(flowattribute.customattribute.type=="string")
                {
                    the_val = flowattribute.customattribute.supplierattributes[0].attibutetextval
                }

                if(flowattribute.customattribute.type=="number")
                {
                    the_val = flowattribute.customattribute.supplierattributes[0].attibutenumericalval
                }

                if(flowattribute.customattribute.type=="boolean")
                {
                    if(flowattribute.customattribute.supplierattributes[0].attibutenumericalval===1)
                    {
                        the_val = "+"
                    }
                    if(flowattribute.customattribute.supplierattributes[0].attibutenumericalval===0)
                    {
                        the_val = "x"
                    }
                }
                if(flowattribute.customattribute.type=="select")
                {
                    let selected_option = flowattribute.customattribute.options.find(item=>item.id == flowattribute.customattribute.supplierattributes[0].attibutenumericalval)
                    if(selected_option)
                    {
                        the_val = selected_option.name
                    }
                }
                if(flowattribute.customattribute.type=="multiselect")
                {
                    console.log("multiselect")
                    console.log(flowattribute)
                    let selected_arr = flowattribute.customattribute.supplierattributes[0].attibutetextval
                    if(selected_arr)
                    {
                        console.log("selected_arr")
                        console.log(selected_arr)
                        the_val = ""
                        selected_arr = JSON.parse(selected_arr)
                        for(let selected_arr_item of selected_arr)
                        {
                            let the_option = flowattribute.customattribute.options.find(item=>item.id == selected_arr_item)
                            if(the_option)
                            {
                                the_val = the_val+the_option.name+", "
                            }                            
                        }
                        the_val = the_val.slice(0, -2); 
                    }
                }

                this.worksheet.addRow([flowattribute.customattribute.name,the_val]);
                this.activerow++
            }
        }
        //flowattributes



        
        

        this.activerow = 1
        //cover





        this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.soru_listesi_isaretlemeleri);

        let options_arr = [""]
        for(let option of data.options)
        {
            let option_name = this.getNameTranslation(option)
            options_arr.push(option_name)
        }
        this.questionlist_options = data.options
        this.worksheet.addRow(options_arr);
        this.worksheet.getCell('A'+this.activerow).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'FF91D2FF'}
        };
        this.activerow++

        for (let index = 0; index < store.state.evaluation.parentsections.length; index++)
        {
            if(store.state.evaluation.parentsections.length>1)
            {
                let section_name = this.getNameTranslation(store.state.evaluation.parentsections[index])
                this.worksheet.addRow([section_name]);

                this.worksheet.getCell('A'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'FF91D2FF'}
                };
                this.activerow++
            }

            let child_inputfields = this.getSectionInputfieldsForReport(store.state.evaluation.parentsections[index].id)
            for(let inputfield of child_inputfields)
            {
                this.addInputfieldName(inputfield,payload)
            }
            this.getChildSections(store.state.evaluation.parentsections[index].id,payload)
        }
        this.activerow = 1

        //nonconformities worksheet
        let action_plan = await this.generalApiGetWithoutLoader("get_audit_nonconformities/"+payload.flowsupplier.audit.uuid)
        let nonconformities = []
        for(let item of action_plan.nonconformities)
        {
            nonconformities.push(this.prepareNonconformity(item))
        }
        this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.aksiyon_plani);
        this.worksheet.columns = [
          { header: store.state.languages.lang_phrases.soru, key: 'name', width: 10 },
          { header: 'Denetim Bulgusu', key: 'note', width: 32 },
          { header: store.state.languages.lang_phrases.uygunsuzluk_tipi, key: 'type', width: 10, outlineLevel: 1 }
        ];
        for(let the_nonconformity of nonconformities)
        {
            this.worksheet.addRow([the_nonconformity.inputfield,the_nonconformity.sub_note,the_nonconformity.type])
        }
        //nonconformities worksheet

        //points worksheet
        if(payload.quizresult)
        {
            this.worksheet = this.workbook.addWorksheet(store.state.languages.lang_phrases.puan);
            this.worksheet.addRow([store.state.languages.lang_phrases.puan,payload.quizresult.percentage_over_points +" / "+ payload.quizresult.points.toFixed(2)]);
            this.worksheet.getCell('A'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'FF91D2FF'}
                };
            this.worksheet.getCell('B'+this.activerow).fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'ffa4ffa4'}
                };
            this.activerow++
            this.worksheet.addRow([store.state.languages.lang_phrases.basari_yuzdesi,payload.quizresult.percentage+"%"]);
            this.worksheet.getCell('A'+this.activerow).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'FF91D2FF'}
            };
            this.worksheet.getCell('B'+this.activerow).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'ffa4ffa4'}
            };
            if(payload.flowsupplier.flow.calculationattribute)
            {
                
                let attribute_data = this.getOptionDataForReport(payload.flowsupplier.flow.calculationattribute.options,payload.flowsupplier.flow.calculationattribute.supplierattributes[0].attibutenumericalval)
                if(attribute_data)
                {
                    this.activerow++
                    this.worksheet.addRow([store.state.languages.lang_phrases.basari_durumu,attribute_data.name]);
                    this.worksheet.getCell('A'+this.activerow).fill = {
                        type: 'pattern',
                        pattern:'solid',
                        fgColor:{argb:'FF91D2FF'}
                    };
                    this.worksheet.getCell('B'+this.activerow).fill = {
                        type: 'pattern',
                        pattern:'solid',
                        fgColor:{argb:attribute_data.color}
                    };

                }
            }
                
        }
        //points worksheet

        this.workbook.xlsx.writeBuffer()
        let flowname= this.getTheTranslation(payload.flowsupplier.flow,"translation")
        this.workbook.xlsx.writeBuffer()
        .then(buffer => saveAs(new Blob([buffer]), `${payload.flowsupplier.supplier.name+"-"+flowname}.xlsx`))
        
        this.activerow = 1
        this.downloading_excel = false
        this.workbook =null
        this.worksheet =null



    },
    prepareNonconformity(nonconformity)
    {
      let the_nonconformity = {}
      the_nonconformity.inputfield = this.getNameTranslation(nonconformity.inputfield)
      the_nonconformity.sub_note = nonconformity.inputfield.submissions[0].submission_note
      the_nonconformity.type = this.getNameTranslation(nonconformity.nonconformitytype)

      return the_nonconformity
    },
    getSectionInputfieldsForReport(section_id)
    {      
      let inputfields = store.state.evaluation.inputfields.filter((item)=>{
        
        return item.inputfieldsection_id == section_id && item.show_field
      })
      return inputfields
    },


    addInputfieldName(inputfield,payload)
    {
     
      if(inputfield.type=="readonlytext")
      {
        return 
      }
      
      if(inputfield.submissions.length && inputfield.submissions[0].is_nulled)
      {
        this.worksheet.addRow([this.getNameTranslation(inputfield),store.state.languages.lang_phrases.bos_birakilmis],"");

        this.worksheet.getCell('B'+this.activerow).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'ffd32f2f'}
        };
        if(inputfield.submissions[0].null_reason)
        {
          let null_reasons = store.state.evaluation.nullreasons
          let null_reason = null_reasons.find((item)=>item.id == inputfield.submissions[0].null_reason)
          if(null_reason)
          {
            this.worksheet.getCell('C'+this.activerow).value = this.getNameTranslation(null_reason);
            this.worksheet.getCell('C'+this.activerow).fill = {
              type: 'pattern',
              pattern:'solid',
              fgColor:{argb:'ffd32f2f'}
            };
          }          
        }
      }
      else
      {
        if(payload.flowsupplier.flow.type!=="audit")
        {
          this.worksheet.addRow([this.getNameTranslation(inputfield)]);
        }
        
      }
      if(payload.flowsupplier.flow.type!=="audit")
      {
        this.worksheet.getCell('A'+this.activerow).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'ffa4ffa4'}
        };

        this.activerow++
      }      
      
      this.addInputfieldAnswers(inputfield,payload)
    },
    addInputfieldAnswers(inputfield,payload)
    {
      
      if(inputfield.type=="columns")
      {
        let column_name_row = []
        let column_answers_row = []
        for(let column of inputfield.columns)
        {
          
          let name = this.getNameTranslation(column)
          column_name_row.push(name) 
          let submission_text
          let submission 

          if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
          {
            submission_text = JSON.parse(inputfield.submissions[0].submission_text)
            submission = submission_text.find((item)=>item.id == column.id)
          }
          if(column.type=="readonly") 
          {
            let readonly_val = column.translations.find((item)=>{return item.language_id == store.state.auth.user.preflang_id})
            column_answers_row.push(readonly_val.readonly)
          }
          if(column.type=="number" || column.type=="text")
          {
            if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
            {              
              if(!submission || !submission.value)
              {
                column_answers_row.push("-")
              }
              else
              {
                column_answers_row.push(submission.value)
              }              
            }
            else
            {
              column_answers_row.push("-")
            }  
          }
          if(column.type=="select")
          {
            if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
            {              
              if(!submission || !submission.value)
              {
                column_answers_row.push("-")
              }
              else
              {
                let theoption = column.options.find(element=>element.id == submission.value)
                if(theoption)
                {
                  column_answers_row.push(this.getNameTranslation(theoption))
                }
                else
                {
                  column_answers_row.push("-")
                }
                
              }              
            }
            else
            {
              column_answers_row.push("-")
            } 
          }
          if(column.type=="custom")
          {
            if(column.submit_to_db)
            {
              if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
              {              
                if(!submission || !submission.value)
                {
                  column_answers_row.push("-")
                }
                else
                {
                  column_answers_row.push(submission.value)
                }              
              }
              else
              {
                column_answers_row.push("-")
              }
            }
            else
            {
              column_answers_row.push("-")
            }
            
          }
        }
        this.worksheet.addRow(column_name_row);
        this.activerow++
        this.worksheet.addRow(column_answers_row);
        this.activerow++
      }

      //select
      if(inputfield.type=="select")
      {
        if(!inputfield.submissions.length)
        {
          return
        }
        let submission_option = inputfield.submissions[0].submission_option
        //if audit
        
        if(payload.flowsupplier.flow.type=="audit")
        {
          let the_row_arr = []
          for (let i = 0; i < this.questionlist_options.length+1; i++)
          {
            the_row_arr.push("")
          }
          this.worksheet.addRow(the_row_arr);
           this.worksheet.getCell("A"+this.activerow).value = this.getNameTranslation(inputfield)
          if(inputfield.submissions.length && inputfield.submissions[0].submission_option)
          {
            let submission_option = inputfield.submissions[0].submission_option
            let the_index = this.questionlist_options.findIndex((item)=>item.id == submission_option)
            if(the_index!==-1)
            {
              let key_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N"]

              this.worksheet.getCell(key_arr[the_index+1]+this.activerow).value = "+"
              this.worksheet.getCell(key_arr[the_index+1]+this.activerow).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'ffa4ffa4'}
            };
            }
          }
          this.activerow++
        }
        //if audit

        //if self eval
        if(payload.flowsupplier.flow.type=="self_evaluation" || payload.flowsupplier.flow.type=="verification")
        {

          for(let option of inputfield.options)
          {
            if(option.id==submission_option)
            {
              this.worksheet.addRow([this.getNameTranslation(option),"+"]);
              this.worksheet.getCell('B'+this.activerow).fill = {
                type: 'pattern',
                pattern:'solid',
                fgColor:{argb:'ffa4ffa4'}
            };
            }
            else
            {
              this.worksheet.addRow([this.getNameTranslation(option)," "]);
            }
            this.activerow++
          }
          
        }
        //if self eval

        
      }
      //select


      if(inputfield.type=="multiselect")
      {
        let submission_text
        if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
        {
          submission_text = JSON.parse(inputfield.submissions[0].submission_text)
        }
        for(let option of inputfield.options) 
        {
          if(submission_text.includes(option.id))
          {
            this.worksheet.addRow([this.getNameTranslation(option),"+"]);
            this.worksheet.getCell('B'+this.activerow).fill = {
              type: 'pattern',
              pattern:'solid',
              fgColor:{argb:'ffa4ffa4'}
            };
          }
          else
          {
            this.worksheet.addRow([this.getNameTranslation(option)," "]);
          }
          this.activerow++
        }

      }
      if(inputfield.type=="text" || inputfield.type=="longtext")
      {         
        if(inputfield.submissions.length && inputfield.submissions[0].submission_text)
        {
          let submission_text = inputfield.submissions[0].submission_text
          this.worksheet.addRow([submission_text]);
        }
        else
        {
          this.worksheet.addRow(["-"]);
        }
        this.activerow++
      }
      if(inputfield.type=="number")
      {
        if(inputfield.submissions.length && inputfield.submissions[0].submission_numerical)
        {
          let submission_numerical = inputfield.submissions[0].submission_numerical
          if(submission_numerical)
          {
            this.worksheet.addRow([submission_numerical.toString()]);
          }
          else
          {
            this.worksheet.addRow(["-"]);
          }

        }        
        else
        {
          this.worksheet.addRow(["-"]);
        }
        
        
        this.activerow++
      }
      if(inputfield.type=="boolean")
      {
        
      }
      if(inputfield.type=="listselect")
      {
        
      }
    },
    getChildSections(parent_id,payload)
    {

      let sections = store.state.evaluation.sections.filter((item)=> item.parent_id == parent_id)
      for(let section of sections)
      {        
        this.worksheet.addRow([this.getNameTranslation(section)]);
        this.worksheet.getCell('A'+this.activerow).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'FF91D2FF'}
        };
        this.activerow++

        let child_inputfields = this.getSectionInputfieldsForReport(section.id)
        for(let inputfield of child_inputfields)
        {          
          this.addInputfieldName(inputfield,payload)
        }
        this.getChildSections(section.id,payload)
      }

    },
    getNameTranslation(item)
    {
      let name = item.name
      if(item.translations.length)
      {
        let translation = item.translations.find((item)=>item.language_id == store.state.auth.user.preflang_id)
        if(translation)
        {
          name = translation.translation
        }

      }
      return name
    },
    getOptionDataForReport(options,id)
    {
      let item = options.find(item=>item.id == id)
      if(item)
      {
        if(item.color)
        {
            let color = item.color.replace("#","")
            return {
                color:item.color,
                name:this.getTheTranslation(item,"translation")
            }
         
        }
        else
        {
          return {
                color:null,
                name:this.getTheTranslation(item,"translation")
            }
        }
      }
      return null
    },
    async getUserIp()
    {
        
        axios.get("https://api.ipify.org?format=jsonp&callback=?")
        .then((resp)=>
        {
            
            let theip = resp.data.replace('?({"ip":"',"")
            theip = theip.replace('"});',"")
            //console.log(theip)
            store.dispatch('auth/setUserIp',theip) 
        })
        
        //let response = await fetch("https://api.ipify.org?format=jsonp&callback=?")
        //console.log(response)
        //let ip = await response.json()
        //console.log(ip)
    },
    generateId()
    {
        return Math.floor(Date.now() / 10)
    },
    async checkUserMenu()
    {        
        let user = store.state.auth.user
        let uuid = store.state.auth.user.uuid
        let return_menu = []   

        let dashboard = {
                key:"dashboard",
                title:"dashboard",
                link:"/"+uuid+"/dashboard",
                capital:"D",
                color:"#ea2c54",
            }  
        return_menu.push(dashboard) 

        let operations_menuseperator = {
            key:"menuseperator",
            title:"operasyon",
            link:"",
            capital:"O",
            color:"#4d4d4d",
        }
        let tickets = {
            key:"tickets",
            title:"destek_talepleri",
            link:"/"+uuid+"/tickets",
            capital:"T",
            color:"#4d4d4d",
            show_bange:false
        }
        let audits_menuseperator = {
            key:"menuseperator",
            title:"planlama",
            link:"",
            capital:"A",
            color:"#4d4d4d",
        }
        let audit_schedules = {
            key:"audit_schedules",
            title:"denetleme_planlama",
            link:"/"+uuid+"/audit_schedules",
            capital:"A",
            color:"#4d4d4d",
        }
        let system_menuseperator = {
            key:"menuseperator",
            title:"sistem",
            link:"",
            capital:"S",
            color:"#4d4d4d",
        }
        let languages = {
            key:"languages",
            title:"diller",
            link:"/"+uuid+"/languages",
            capital:"L",
            color:"#4d4d4d",
        }        
        let generalpurposedatatypes = {
            key:"generalpurposedatatypes",
            title:"genel_data_tipleri",
            link:"/"+uuid+"/generalpurposedatatypes",
            capital:"G",
            color:"#4d4d4d",
        }
        let certificatetypes = {
            key:"certificatetypes",
            title:"sertifika_tipleri",
            link:"/"+uuid+"/certificatetypes",
            capital:"L",
            color:"#4d4d4d",
        }
        let users = {
            key:"users",
            title:"kullanicilar",
            link:"/"+uuid+"/users",
            capital:"U",
            color:"#4d4d4d",
        }        
        let verifications = {
            key:"verifications",
            title:"dogrulama_planlama",
            link:"/"+uuid+"/verifications",
            capital:"V",
            color:"#4d4d4d",
        }

        let preaudits = {
            key:"preaudits",
            title:"on_planlamalar",
            link:"/"+uuid+"/preaudits",
            capital:"O",
            color:"#4d4d4d",
        }
        let suppliers = {
            key:"suppliers",
            title:"suppliers",
            link:"/"+uuid+"/suppliers",
            capital:"S",
            color:"#4d4d4d",
        }
        let auditor_verifications = {
            key:"auditor_verifications",
            title:"dogrulama_gorusmeleri",
            link:"/"+uuid+"/auditor_verifications",
            capital:"D",
            color:"#4d4d4d",
        }
        let auditor_audits = {
            key:"auditor_audits",
            title:"denetlemeler",
            link:"/"+uuid+"/auditor_audits",
            capital:"D",
            color:"#4d4d4d",
        }        
        let brands = {
            key:"brands",
            title:"markalar",
            link:"/"+uuid+"/brands",
            capital:"B",
            color:"#4d4d4d",
        }
        let projects = {
            key:"projects",
            title:"projeler",
            link:"/"+uuid+"/projects",
            capital:"P",
            color:"#4d4d4d",
        }

        let closurerequests = {
            key:"closurerequests",
            title:"kapatma_talepleri",
            link:"/"+uuid+"/closurerequests",
            capital:"C",
            color:"#4d4d4d",
        }

        let certificate_uploads = {
            key:"certificate_uploads",
            title:"sertifika_yuklemeleri",
            link:"/"+uuid+"/certificate_uploads",
            capital:"C",
            color:"#4d4d4d",
        }

        let flows = {
            key:"flows",
            title:"akislar",
            link:"/"+uuid+"/flows",
            capital:"F",
            color:"#4d4d4d",
        }
        let questionlists = {
            key:"questionlists",
            title:"soru_listeleri",
            link:"/"+uuid+"/questionlists",
            capital:"Q",
            color:"#4d4d4d",
            //show_bange:true
        }
        let questionlist_previews = {
            key:"questionlist_previews",
            title:"soru_listeleri",
            link:"/"+uuid+"/questionlist_previews",
            capital:"Q",
            color:"#4d4d4d",
            //show_bange:true
        }
        let educationpacks = {
            key:"educationpacks",
            title:"egitim_paketleri",
            link:"/"+uuid+"/educationpacks",
            capital:"E",
            color:"#4d4d4d",
        }


        let countries = {
            key:"countries",
            title:"ulkeler",
            link:"/"+uuid+"/countries",
            capital:"U",
            color:"#4d4d4d",
        }

        
        
        if(user)
        {   
            let the_userroles = [] 

            let brand = user.userroles.findIndex((item)=>{return item.name=="brand"})
            let supplier = user.userroles.findIndex((item)=>{return item.name=="supplier"})
            let admin = user.userroles.findIndex((item)=>{return item.name=="admin"})
            let planner = user.userroles.findIndex((item)=>{return item.name=="planner"})
            let auditor = user.userroles.findIndex((item)=>{return item.name=="auditor"})  
            let technical_auditor = user.userroles.findIndex((item)=>{return item.name=="technical_auditor"})  
            
            if(brand!==-1)
            {
                the_userroles.push("brand")
                return_menu.push(brands) 
                return_menu.push(projects) 
                return_menu.push(flows) 
                return_menu.push(questionlists) 
                return_menu.push(educationpacks) 
                return_menu.push(audits_menuseperator) 
                return_menu.push(verifications) 
                return_menu.push(audit_schedules) 
                return_menu.push(certificate_uploads) 
                //return_menu.push(preaudits)

            }
            if(supplier!==-1)
            {
                let supplier_tickets_open = await this.generalApiGetWithoutLoader("tickets/get_open_supplier_tickets") 
                await this.getSupplierOpenNotifications()
                
                if(supplier_tickets_open!=="close")
                {
                   store.dispatch('tickets/setOpenTicket',true) 
                   store.dispatch('tickets/setOpenTicketsCount',supplier_tickets_open) 
                }
                the_userroles.push("supplier")
                let supplier_evaluations = store.state.evaluation.evaluations
                let badge = false
                if(supplier_evaluations.length)
                {
                    badge = true
                }
                let supplier_brands = {
                    key:"supplierbrands",
                    title:"tedarikci_markalari",
                    link:"/"+uuid+"/supplierbrands",
                    capital:"S",
                    color:"#4d4d4d",
                    show_bange:badge
                }  

                return_menu.push(supplier_brands)  
            }            
            if(admin!==-1)
            {
                let tickets_open = await this.generalApiGetWithoutLoader("tickets/get_open_admin_tickets")  
                             
                if(tickets_open!=="close")
                {
                   store.dispatch('tickets/setAdminOpenTickets',true) 
                   store.dispatch('tickets/setAdminOpenTicketsCount',tickets_open) 
                }
                the_userroles.push("admin")
                return_menu.push(operations_menuseperator) 
                return_menu.push(brands) 
                return_menu.push(projects) 
                return_menu.push(flows) 
                return_menu.push(questionlists) 
                return_menu.push(educationpacks) 
                return_menu.push(tickets) 
                return_menu.push(suppliers)
                return_menu.push(audits_menuseperator) 
                return_menu.push(verifications) 
                return_menu.push(audit_schedules) 
                //return_menu.push(preaudits)  
                return_menu.push(closurerequests) 
                return_menu.push(certificate_uploads) 
                return_menu.push(system_menuseperator) 
                //return_menu.push(generalpurposedatatypes)
                return_menu.push(certificatetypes) 
                return_menu.push(countries) 
                return_menu.push(users)  
                return_menu.push(languages) 
            }

            if(planner!==-1 )
            {
                the_userroles.push("planner")

                let if_brands = return_menu.findIndex((item)=>{return item.key=="brands"})
                if(if_brands==-1)
                {
                    return_menu.push(brands)
                }

                let if_projects = return_menu.findIndex((item)=>{return item.key=="projects"})
                if(if_projects==-1)
                {
                    return_menu.push(projects)
                }
                
                let if_flows = return_menu.findIndex((item)=>{return item.key=="flows"})
                if(if_flows==-1)
                {
                    return_menu.push(flows)
                }
                
                let if_verifications = return_menu.findIndex((item)=>{return item.key=="verifications"})
                if(if_verifications==-1)
                {
                    return_menu.push(verifications)
                }
                /*

                let if_preaudits = return_menu.findIndex((item)=>{return item.key=="preaudits"})
                if(if_preaudits==-1)
                {
                    return_menu.push(preaudits)
                }
                */

                let if_audit_schedules = return_menu.findIndex((item)=>{return item.key=="audit_schedules"})
                if(if_audit_schedules==-1)
                {                    
                    return_menu.push(audit_schedules) 
                }
                
                let if_suppliers = return_menu.findIndex((item)=>{return item.key=="suppliers"})
                if(if_suppliers==-1)
                {
                    return_menu.push(suppliers)
                }

                let if_tickets = return_menu.findIndex((item)=>{return item.key=="tickets"})
                if(if_suppliers==-1)
                {
                    return_menu.push(tickets)
                }
            }
            if(auditor!==-1)
            {
                the_userroles.push("auditor")  
                let if_questionlist_previews = return_menu.findIndex((item)=>{return item.key=="questionlist_previews"})
                if(if_questionlist_previews==-1)
                {
                    return_menu.push(questionlist_previews)
                } 
                let if_suppliers = return_menu.findIndex((item)=>{return item.key=="suppliers"})
                if(if_suppliers==-1)
                {
                    return_menu.push(suppliers)
                }
                let if_auditor_verifications = return_menu.findIndex((item)=>{return item.key=="auditor_verifications"})
                if(if_auditor_verifications==-1)
                {
                    return_menu.push(auditor_verifications)
                }
                let if_auditor_audits = return_menu.findIndex((item)=>{return item.key=="auditor_audits"})
                if(if_auditor_audits==-1)
                {
                    return_menu.push(auditor_audits)
                } 
                             
            }
            if(technical_auditor!==-1)
            {
                the_userroles.push("technical_auditor")
                if(!the_userroles.includes("admin"))
                {
                    return_menu.push(audits_menuseperator) 
                    return_menu.push(verifications) 
                    return_menu.push(audit_schedules) 
                }
            }



            store.dispatch('auth/setUserRoles',the_userroles) 
            

            
            return return_menu

        }
        else
        {
            return []
        }
    },
    async getSupplierOpenNotifications()
    {        
        let data = await this.generalApiGetWithoutLoader("get_supplier_open_notifications") 
        console.log("getSupplierOpenNotifications")
        console.log(data)
        await store.dispatch('auth/setSupplierNotifications',data) 
    },
    gotoPage(routename,params)
    {
        
        if(params)
        {
            this.$router.push({ name: routename, params })
        }
        else
        {
            console.log("no params")
            this.$router.push({ name: routename })
        }
        
    },
    async deleteItem(item,id)
    {   
        let theid = id
        if(id instanceof Object)
        {
            theid = id[Object.keys(id)[0]]
        }
        await this.$confirm.require({
            message: store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
            header: store.state.languages.lang_phrases.silme_uyarisi,
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger p-button-outlined',
            acceptLabel:store.state.languages.lang_phrases.devam_et,
            rejectLabel:store.state.languages.lang_phrases.iptal,
            accept: async () => {
                await this.$store.dispatch('ui/setDeletedState',false) 
                let formdata = await new  FormData()
                await this.generalSubmission(formdata,item+"/delete/"+theid,this.afterDelete)
            },
            reject: () => {
                
            }
        });
    },
    afterDelete(response)
    {
        console.log(response.data)
        this.$store.dispatch('ui/setDeletedState',true) 
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateForm(fields)
    {
        let has_error = false
        for(let item of fields)
        {
            //required
            if(item.is_required)
            {
                if(!item.value || item.value=="")
                {
                    item.has_error = true
                    item.error_message = ": bu alan zorunludur."
                    has_error = true
                }
            }
            //required
            //email
            if(item.is_email)
            {
                if(!this.validEmail(item.value))
                {
                    item.has_error = true
                    item.error_message = ": alan için geçerli bir email girin."
                    has_error = true
                }
            }
            //email 
            //min_length
            if(item.min_length)
            {
                if(item.value && item.value.length<item.min_length)
                {
                    item.has_error = true
                    item.error_message = ": alan "+item.min_length+" karakterden uzun olmalı."
                    has_error = true
                }
            }
            //min_length 
            //max_length
            if(item.max_length)
            {
                if(item.value && item.value.length>item.max_length)
                {
                    item.has_error = true
                    item.error_message = ": alan "+item.max_length+" karakterden kısa olmalı."
                    has_error = true
                }
            }
            //max_length   
            //chips
            if(item.type=="chips" && item.value.length==0 && item.show)
            {
                if(item.value && item.value.length>item.max_length)
                {
                    item.has_error = true
                    item.error_message = ": alan en az 1 opsiyon barındırmalı"
                    has_error = true
                }
            }
            //chips





        }
        return {
                has_error:has_error,
                fields:fields
            }
    },
    sanitizeArray(arr)
    {        
        return  JSON.parse(JSON.stringify(arr))
    },
    createFormData(fields)
    {
        let formdata = new FormData()
        for(let item of fields)
        {
            if(item.value || item.value===0)
            {
                if(item.type=="multiselect" || item.type=="chips" )
                {
                    formdata.append(item.key,JSON.stringify(item.value))
                }
                else
                {
                    if(item.type=="switch")
                    {
                        if(item.value)
                        {
                            item.value = 1
                        }
                        else
                        {
                            item.value = 0
                        }
                    }
                    if(item.type=="date" && item.value)
                    {
                        item.value = moment(item.value).format()
                    }
                    if(item.type=="select")
                    {
                        item.value = item.value.id
                    }
                    formdata.append(item.key,item.value)
                }

            }
            
            
        }
        return formdata
    },
    convertData(data)
    {
        return JSON.parse(JSON.stringify(data))
    },
    async getLanguageData()
    {
        let userLang = navigator.language || navigator.userLanguage;
        userLang = userLang.slice(0, 2);
        let lang_phrases
        if(userLang=="tr")
        {
            lang_phrases = await this.silentApiGet("get_language_translations/3")
        }
        else
        {
            lang_phrases = await this.silentApiGet("get_language_translations/15")
        }
         
        await store.dispatch('languages/setLangPhrases',lang_phrases)
    },
    async getUserData()
    {
        store.dispatch('auth/setSupplierHaveOpenCustomAttributes',false) 
        store.dispatch('auth/setSupplierOpenCustomAttributes',[])
        let data = await this.silentApiGet("get_user_data") 
        //await console.log("get_user_data")
        //console.log(process.env.VUE_APP_API_HOOK)
        console.log(data)
        let lang_phrases = await this.silentApiGet("get_language_translations/"+data.user.preflang_id)         
        await store.dispatch('auth/setUser',data.user)
        await store.dispatch('languages/setLanguages',data.languages)
        await store.dispatch('languages/setLangPhrases',lang_phrases)
        
        if(this.$route && this.$route.meta.title)
        {
            console.log(this.$route)
            document.title = store.state.languages.lang_phrases[this.$route.meta.title]+" - VerifyHub"
        }
        let user = await data.user
        let supplier = await user.userroles.findIndex((item)=>{return item.name=="supplier"})
        if(supplier!==-1)
        {
            let supplier_evaluations = await this.silentApiGet("awaiting_audits") 
            //let consent_statuses = await this.silentApiGet("get_supplier_consent_status") 
            await console.log("supplier_evaluations")
            await console.log(supplier_evaluations)
            
            await store.dispatch('evaluation/setEvaluations',supplier_evaluations)
            //await store.dispatch('auth/setConsentStatuses',consent_statuses)
        }
        //await store.commit('users/SET_USER', data)

        //connect to user_channel
        //this.$socket.emit('create_user_channel', { client: this.$store.state.auth.user.uuid })
        //console.log("create_user_channel");


        let the_userroles = await [] 
        let brand = user.userroles.findIndex((item)=>{return item.name=="brand"})
        let supplier_type = user.userroles.findIndex((item)=>{return item.name=="supplier"})
        let admin = user.userroles.findIndex((item)=>{return item.name=="admin"})
        let planner = user.userroles.findIndex((item)=>{return item.name=="planner"})
        let auditor = user.userroles.findIndex((item)=>{return item.name=="auditor"})  


        if(brand!==-1)
        {
            the_userroles.push("brand")
           
        }
        if(supplier_type!==-1)
        {
            let supplier_open_custom_attributes = await this.silentApiGet("get_supplier_must_submit_custom_attributes") 
            console.log("supplier_open_custom_attributes")
            console.log(supplier_open_custom_attributes)
            if(supplier_open_custom_attributes.length)
            {
                store.dispatch('auth/setSupplierHaveOpenCustomAttributes',true) 
                store.dispatch('auth/setSupplierOpenCustomAttributes',supplier_open_custom_attributes) 
            }
            the_userroles.push("supplier")
        }
        
        if(planner!==-1 )
        {
            the_userroles.push("planner")
        }
        if(auditor!==-1)
        {
            the_userroles.push("auditor")
        }
        if(admin!==-1)
        {
            the_userroles.push("admin")
        }
        store.dispatch('auth/setUserRoles',the_userroles) 

        await app.config.globalProperties.$socket.emit('create_user_channel', { client: store.state.auth.user.uuid })
        await store.dispatch('ui/setAppLoaded',true)

        
        let usermenu = await this.checkUserMenu()
        await store.dispatch('ui/setUserMenu',usermenu)  

        
        setTimeout(async ()=>{
            if(!data.user.userdatachecked)
            {
               
                //await store.dispatch('auth/setRedirectRoute',router.currentRoute.value)
                //await router.push({ name: 'UserGeneral', params: { id: "profile",uuid:data.user.uuid } })
            }  
        })    
        return data
    },

    logout()
    {
      console.log("logout")
      let formdata = new FormData()      
      this.generalSubmission(formdata,"logout",this.afterLogout)
    },
    afterLogout(response)
    {
        //console.log(response.data)
        
        localStorage.removeItem("vrf_token");
        if(this.$router)
        {
            this.$router.push({ path: '/login' })
        }
        else
        {
            location.reload();
        }
        setTimeout(()=>{
            store.dispatch('auth/setToken',null)
            store.dispatch('auth/setUser',null)
        })
        
        

    },
    onResize () {
        //console.log("onResize");
      if(window.innerWidth>768)
      {
        //store.dispatch('ui/setMenuOpen',false)
        store.dispatch('ui/setUserMenuOpen',false)
        store.dispatch('ui/setViewDevice',"desktop")        
      }
      else{
        store.dispatch('ui/setViewDevice',"mobile") 
      }
      
    },
    getId()
    {
        let loc = window.location.href
        let id = loc.substring(loc.lastIndexOf("/")+1)
        id = id.replace("#","")
        return id
    },
    
    

    loadingAreaAdjust(loadingarea,condition)
    {
        if(loadingarea=="main")
        {
            store.dispatch('ui/setMainFrameLoading',condition)
        }
        if(loadingarea=="content")
        {
            store.dispatch('ui/setLoggedin',condition)
        }
        if(loadingarea=="tiny")
        {
            store.dispatch('ui/setLoggedin',condition)
        }

    },
	generalApiGet(url,headers=null)
    {
        //this.loadingAreaAdjust(loadingarea,true)        
        store.dispatch('ui/setContentFrameLoading',true) 

        //this.getUserIp()
        let promise = new Promise((resolve, reject)=>{
        axios.get(url)
        .then((response) => {   
            //this.loadingAreaAdjust(loadingarea,false) 
            setTimeout(()=>{
                store.dispatch('ui/setContentFrameLoading',false)  
            },10)
                     
            resolve(response.data)
        },
        (error) => {
            console.log(error)
            store.dispatch('ui/setContentFrameLoading',false) 
            if(error.response.status==401)
            {
                localStorage.removeItem("vrf_token");
                this.afterLogout("401")
                return false
                return error.response.data

               
            }

            console.log(error.response)
            this.$store.dispatch('ui/setErroMessage',"Bir hata oluştu") 
            this.$store.dispatch('ui/setErrorNotif',true) 
            //this.loadingAreaAdjust(loadingarea,false)
            resolve(error)
            
        }
        )
        })
        return  promise
    },

    silentApiGet(url,loadingarea)
    {
        //this.loadingAreaAdjust(loadingarea,true)        
         

        let promise = new Promise((resolve, reject)=>{
        axios.get(url)
        .then((response) => {   
            //this.loadingAreaAdjust(loadingarea,false) 
            setTimeout(()=>{ 
            },10)
                     
            resolve(response.data)
        },
        (error) => {
            console.log("error")
            console.log(error)
            if(error.response.status==401)
            {
                console.log("401")
                localStorage.removeItem("vrf_token");
                this.afterLogout("401")
                return false
                //return error.response.data
               
            }
            else
            {
                console.log(error.response)
                this.$store.dispatch('ui/setErroMessage',"Bir hata oluştu") 
                this.$store.dispatch('ui/setErrorNotif',true) 
            }

            
            //this.loadingAreaAdjust(loadingarea,false)
            resolve(error)
            
        }
        )
        })
        return  promise
    },
    generalApiGetWithoutLoader(url,loadingarea)
    {
        

        let promise = new Promise((resolve, reject)=>{
        axios.get(url)
        .then((response) => {   
            setTimeout(()=>{
               
            },10)
                     
            resolve(response.data)
        },
        (error) => {
            console.log(error)
            if(error.response.status==401)
            {
                localStorage.removeItem("vrf_token");
                this.afterLogout("401")
                return false
                return error.response.data               
            }
            console.log(error.response)
            this.$store.dispatch('ui/setErroMessage',"Bir hata oluştu") 
            this.$store.dispatch('ui/setErrorNotif',true) 
            resolve(error)            
        }
        )
        })
        return  promise
    },
    async generalValidationCheck()
    {
        await this.$refs.formobserver.validate() 
        return await this.$refs.formobserver.flags.failed
        
        
    },
    showMessage(status,title,message)
    {
         this.$toast.add({severity:status, summary: title, detail:message, group: 'br', life: 3000});

    },
	generalSubmission(formData,posturl,responseaction)
    {
    
    //this.loadingAreaAdjust(loadingarea,true)
    store.dispatch('ui/setSubmitting',true) 
    axios.post(posturl, formData)
    .then((response) =>{
        //this.loadingAreaAdjust(loadingarea,false)
        store.dispatch('ui/setSubmitting',false) 
        this.showMessage("success","",store.state.languages.lang_phrases.basariyla_kaydedildi)
        responseaction(response)

    })
    .catch( (error) =>{
        //console.log(error)
        //this.loadingAreaAdjust(loadingarea,false)
        console.log(error)
        console.log(error.response)
        this.showMessage("error",store.state.languages.lang_phrases.bir_hata_olustu,store.state.languages.lang_phrases.lutfen_tekrar_deneyin)
        store.dispatch('ui/setSubmitting',false)
        if(error.response)
        {
             if(error.response.status && error.response.status == 419)
            {                   
               console.log("419")                        
            }
            if(error.response.status && error.response.status == 401)
            {              
                if(store.state.auth.user)     
                {
                    localStorage.removeItem("vrf_token");
                    this.afterLogout("401")
                    return false
                }
                else
                {
                    responseaction(error.response) 
                }
                
                                     
            }
            else if(error.response.status && error.response.status == 422)
            {
                let err_messages = error.response.data.errors
                let the_vals = Object.values(err_messages)[0]
                let the_message = the_vals[0]
                
                 responseaction(error.response)
            }
            else
            {
                this.$store.dispatch('ui/setErroMessage',"Bir hata oluştu") 
                this.$store.dispatch('ui/setErrorNotif',true) 
                //this.loadingAreaAdjust(loadingarea,false)
                store.dispatch('ui/setSubmitting',false) 
                //responseaction(error.response)
            }
        }  
        responseaction(error.response)           
       });
    },
    generalSubmissionWithProgress(formData,posturl,responseaction)
    {
    
    //this.loadingAreaAdjust(loadingarea,true)
    store.dispatch('ui/setSubmitting',true) 
    store.dispatch('ui/setUploadProgress',0)
    axios.post(posturl, formData,{
        onUploadProgress: function( progressEvent ) {
        let progress  = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
        store.dispatch('ui/setUploadProgress',progress)       
      }.bind(this)

    })
    .then((response) =>{
        //this.loadingAreaAdjust(loadingarea,false)
        store.dispatch('ui/setSubmitting',false) 
        this.showMessage("success","","Başarıyla kaydedildi")
        store.dispatch('ui/setUploadProgress',0)
        responseaction(response)

    })
    .catch( (error) =>{
        //console.log(error)
        //this.loadingAreaAdjust(loadingarea,false)
        console.log(error)
        console.log(error.response)
        store.dispatch('ui/setUploadProgress',0)
        this.showMessage("error","Bir Hata Oluştu","Lütfen tekrar deneyin")
        store.dispatch('ui/setSubmitting',false)
        if(error.response)
        {
             if(error.response.status && error.response.status == 419)
            {                   
               console.log("419")                        
            }
            if(error.response.status && error.response.status == 401)
            {                   
               responseaction(error.response)                       
            }
            else if(error.response.status && error.response.status == 422)
            {
                let err_messages = error.response.data.errors
                let the_vals = Object.values(err_messages)[0]
                let the_message = the_vals[0]
                
                 responseaction(error.response)
            }
            else
            {
                this.$store.dispatch('ui/setErroMessage',"Bir hata oluştu") 
                this.$store.dispatch('ui/setErrorNotif',true) 
                //this.loadingAreaAdjust(loadingarea,false)
                store.dispatch('ui/setSubmitting',false) 
                //responseaction(error.response)
            }
        }  
        responseaction(error.response)           
       });
    },

    silentSubmission(formData,posturl,responseaction)
    {
    
    //this.loadingAreaAdjust(loadingarea,true)
   
    axios.post(posturl, formData)
    .then((response) =>{
        //this.loadingAreaAdjust(loadingarea,false)
        
        //this.showMessage("success","","Başarıyla kaydedildi")
        responseaction(response)

    })
    .catch( (error) =>{
        //console.log(error)
        //this.loadingAreaAdjust(loadingarea,false)
        console.log(error)
        console.log(error.response)
        if(error.response)
        {
             if(error.response.status && error.response.status == 419)
            {                   
               console.log("419")                        
            }
            if(error.response.status && error.response.status == 401)
            {                   
               responseaction(error.response)                       
            }
            else if(error.response.status && error.response.status == 422)
            {
                let err_messages = error.response.data.errors
                let the_vals = Object.values(err_messages)[0]
                let the_message = the_vals[0]
                
                 responseaction(error.response)
            }
            else
            { 
                //this.loadingAreaAdjust(loadingarea,false)
                //responseaction(error.response)
            }
        }  
        responseaction(error.response)           
       });
    },

    checkTabName(tabs)
    {
      for(let tab of tabs)
      {
        if(this.$route.path.includes(tab.route))
        {
          store.dispatch('ui/setActiveTab',tab.title) 
        }
      }
    },
    getTheTranslation(theobject,field)
    {
        if(theobject.translations && theobject.translations.length)
        {
            let translation = theobject.translations.find((item)=>item.language_id == store.state.auth.user.preflang_id)
            if(translation)
            {
                return translation[field]
            }
            else
            {
                return theobject.translations[0][field]
            }
        }
        else
        {
            return theobject.name
        }

    },
    getTheTranslationByArray(arr,field)
    {
        
        if(arr && arr.length)
        {
            let translation = arr.find((item)=>item.language_id == store.state.auth.user.preflang_id)
            if(translation)
            {
                return translation[field]
            }
            else
            {
                return arr[0][field]
            }
        }
        else
        {
            return ""
        }

    },

},
//methods




}